
import { GetUserWebInfoByid } from "adminApi/UserManageApi/UserManage";

const fetchUserData = async ({ dispatch, token }) => {

  try {
    // Check if token exists
    if (!token) {
      console.error("❌ No token provided to fetchUserData");
      return;
    }

    // decode token to get id
    let decoded;
    try {
      decoded = JSON.parse(
        atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
      );
    } catch (tokenError) {
      console.error("❌ Error decoding token:", tokenError);
      return;
    }

    if (!decoded || !decoded.id) {
      console.error("❌ Invalid token format - missing user id");
      return;
    }

    const id = decoded.id;
    const userData = await GetUserWebInfoByid(id);


    if (userData.data.success && userData.data.data) {
      const user = userData.data.data;
      dispatch({
        type: "SET_USER", payload: {
          email: user.email,
          name: user.firstname,
          id: user.id,
          image: user.image,
          usertype: user.usertype,
          status: user.status,
          is_admin: user.is_admin,
          logo: user.logo,
          site_text: user.site_text
        }
      });
    } else {
      console.error("❌ Failed to fetch user data:", userData.data.error);
    }
  } catch (error) {
    console.error("❌ Error fetching user:", error);
  }
};

export default fetchUserData;
